import { createRouter, createWebHistory, RouteRecordRaw } from 'vue-router'
import HomeView from '../views/HomeView.vue'
import "../style.css"

const routes: Array<RouteRecordRaw> = [
  // {
  //   path: '/',
  //   name: 'home',
  //   component: HomeView
  // },


  // Admin
  {
    path: '/admin',
    name: 'admin',
    component: () => import(/* webpackChunkName: "about" */ '../views/admin/admin.vue'),
  },

  {
    path: '/admin-sign-in',
    name: 'admin-sign-in',
    component: () => import(/* webpackChunkName: "about" */ '../views/admin/admin-sign-in.vue'),
  },



  //New

  {
    path: '/search',
    name: 'c-search',
    component: () => import(/* webpackChunkName: "about" */ '../views/customer/c-search.vue'),
  },
  {
    path: '/addproduct',
    name: 'addproduct',
    component: () => import(/* webpackChunkName: "about" */ '../views/seller/addproduct.vue'),
  },
  {
    path: '/sso',
    name: 'sso',
    component: () => import(/* webpackChunkName: "about" */ '../views/seller/s-s-o.vue'),
  },
  {
    path: '/sp',
    name: 'sp',
    component: () => import(/* webpackChunkName: "about" */ '../views/customer/c-products-show.vue'),
  },
  {
    path: '/payment',
    name: 'c-payment',
    component: () => import(/* webpackChunkName: "about" */ '../views/customer/c-payment-redirect.vue'),
  },



  //Customer
  {
    path: '/',
    name: 'c-index',
    component: () => import(/* webpackChunkName: "about" */ '../views/customer/c-index.vue'),
  },
  {
    path: '/aboutus',
    name: 'c-aboutus',
    component: () => import(/* webpackChunkName: "about" */ '../views/customer/aboutus.vue'),
  },
  {
    path: '/c-sign-in',
    name: 'c-sign-in',
    component: () => import(/* webpackChunkName: "about" */ '../views/customer/c-sign-in.vue'),
  },
  {
    path: '/c-sign-up',
    name: 'c-sign-up',
    component: () => import(/* webpackChunkName: "about" */ '../views/customer/c-sign-up.vue'),
  },
  {
    path: '/product',
    name: 'c-product',
    component: () => import(/* webpackChunkName: "about" */ '../views/customer/c-product.vue'),
  },
  {
    path: '/cart',
    name: 'c-cart',
    component: () => import(/* webpackChunkName: "about" */ '../views/customer/c-my-cart.vue'),
  },

  {
    path: '/checkout',
    name: 'c-checkout',
    component: () => import(/* webpackChunkName: "about" */ '../views/customer/c-check-out.vue'),
  },
  {
    path: '/addticket',
    name: 'c-create-ticket',
    component: () => import(/* webpackChunkName: "about" */ '../views/customer/c-create-ticket.vue'),
  },
  {
    path: '/customersupport',
    name: 'c-customer-support',
    component: () => import(/* webpackChunkName: "about" */ '../views/customer/c-customer-support.vue'),
  },

  {
    path: '/ticketinbox',
    name: 'c-ticket-inbox',
    component: () => import(/* webpackChunkName: "about" */ '../views/customer/c-ticket-inbox.vue'),
  },
  {
    path: '/account',
    name: 'c-profile',
    component: () => import(/* webpackChunkName: "about" */ '../views/customer/c-profile.vue'),
  },
  {
    path: '/store',
    name: 'c-store',
    component: () => import(/* webpackChunkName: "about" */ '../views/customer/c-store.vue'),
  },
  {
    path: '/index-c',
    name: 'c-homepage-category',
    component: () => import(/* webpackChunkName: "about" */ '../views/customer/c-homepage-category.vue'),
  },
  {
    path: '/c-setup-info',
    name: 'c-setup-info',
    component: () => import(/* webpackChunkName: "about" */ '../views/customer/c-setup-shop-info.vue'),
  },


  //Seller
  // {
  //   path: '/s-add-new-product',
  //   name: 's-add-new-product',
  //   component: () => import(/* webpackChunkName: "about" */ '../views/seller/s-add-new-product-responsive.vue'),
  // },
  {
    path: '/s-sign-in',
    name: 's-sign-in',
    component: () => import(/* webpackChunkName: "about" */ '../views/seller/s-sign-in.vue'),
  },
  {
    path: '/s-sign-up',
    name: 's-sign-up',
    component: () => import(/* webpackChunkName: "about" */ '../views/seller/s-sign-up.vue'),
  },
  {
    path: '/s-create-shop-acc',
    name: 's-create-shop-acc',
    component: () => import(/* webpackChunkName: "about" */ '../views/seller/s-create-shop-acc-phone-num.vue'),
  },
  {
    path: '/s-create-shop-acc-ver2',
    name: 's-create-shop-acc-ver2',
    component: () => import(/* webpackChunkName: "about" */ '../views/seller/s-create-shop-acc-ver2.vue'),
  },
  {
    path: '/s-create-shop-acc-ver3',
    name: 's-create-shop-acc-ver3',
    component: () => import(/* webpackChunkName: "about" */ '../views/seller/s-create-shop-acc-ver3.vue'),
  },
  // {
  //   path: '/s-product-all',
  //   name: 's-product-all',
  //   component: () => import(/* webpackChunkName: "about" */ '../views/seller/s-product-all.vue'),
  // },
  {
    path: '/s-setup-shop-info',
    name: 's-setup-shop-info',
    component: () => import(/* webpackChunkName: "about" */ '../views/seller/s-setup-shop-info.vue'),
  },

  //Tests
  {
    path: '/AdminTest',
    name: 'AdminTest',
    component: () => import(/* webpackChunkName: "about" */ '../layouts/AdminTest.vue'),
  },
  {
    path: '/ProductPageTest',
    name: 'ProductPageTest',
    component: () => import(/* webpackChunkName: "about" */ '../layouts/ProductPageTest.vue'),
  },
  {
    path: '/RedirectPage',
    name: 'RedirectPage',
    component: () => import(/* webpackChunkName: "about" */ '../layouts/RedirectPage.vue'),
  },
  {
    path: '/SignUpTest',
    name: 'SignUpTest',
    component: () => import(/* webpackChunkName: "about" */ '../layouts/SignUpTest.vue'),
  },
]

const router = createRouter({
  history: createWebHistory(),
  routes
})

export default router
